module.exports = __webpack_public_path__ + "img/word.6246567b.png";